import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Stars from "@/components/Stars";
import ReviewReply from "@/components/ReviewReply";

export function ProductRatingSummary({ data }) {
  if (!data?.count) return null;
  return (
    <a href="#avis" data-testid="product-rating-summary" className="mt-2 inline-flex items-center gap-2 text-sm text-bark-soft hover:text-amber-deep">
      <Stars value={data.avg} size={15} /> <span className="font-semibold text-bark">{data.avg.toLocaleString("fr-FR")}</span> · {data.count} avis
    </a>
  );
}

export function useProductReviews(productId) {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    if (productId) api.get(`/products/${productId}/reviews`).then(({ data }) => setData(data)).catch(() => setData(null));
  }, [productId]);
  return data;
}

export default function ProductReviews({ data }) {
  if (!data?.count) return null;
  return (
    <section id="avis" data-testid="product-reviews" className="mt-20 scroll-mt-28">
      <div className="mb-6 flex flex-wrap items-end gap-x-4 gap-y-1">
        <h2 className="font-serif text-2xl font-semibold text-bark sm:text-3xl">Avis clients</h2>
        <p className="flex items-center gap-2 pb-1 text-sm text-bark-soft"><Stars value={data.avg} size={15} /> {data.avg.toLocaleString("fr-FR")} / 5 · {data.count} avis vérifiés</p>
      </div>
      {data.reviews.length > 0 && (
        <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {data.reviews.map((r) => (
            <li key={r.id} data-testid={`product-review-${r.id}`} className="rounded-2xl border border-amber-800/10 bg-white p-5">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-semibold text-bark">{r.author}</span>
                <Stars value={r.rating} size={13} />
              </div>
              <p className="mt-3 text-sm leading-relaxed text-bark-soft">« {r.comment} »</p>
              <ReviewReply text={r.reply} testid={`product-review-reply-${r.id}`} />
              <p className="mt-3 text-xs text-stone-mute">{new Date(r.created_at).toLocaleDateString("fr-FR", { month: "long", year: "numeric" })} · achat vérifié</p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
